import axios from "axios";
import { useState } from "react";
import {
  setError,
  setProcessingStatus,
  setResults,
  updateProgress,
} from "../context/bulkUploadActions";
import { useBulkUpload } from "./useBulkUpload";

export const useProcessing = () => {
  const { state, dispatch } = useBulkUpload();
  const [processing, setProcessing] = useState(false);

  const processUpload = async (
    programId,
    branchId,
    courseId,
    branchCourseFeeId,
    courseFee
  ) => {
    setProcessing(true);
    dispatch(setProcessingStatus("processing"));

    try {
      const { valid } = state.validation.results;
      const totalStudents = valid.length;
      const chunkSize = 10; // Process 10 students at a time
      const chunks = [];

      // Split into chunks
      for (let i = 0; i < valid.length; i += chunkSize) {
        chunks.push(valid.slice(i, i + chunkSize));
      }

      let processedCount = 0;
      const allResults = {
        success: [],
        failed: [],
      };

      // Process chunks sequentially
      for (let i = 0; i < chunks.length; i++) {
        const chunk = chunks[i];

        dispatch(
          updateProgress({
            current: processedCount,
            total: totalStudents,
            percentage: Math.round((processedCount / totalStudents) * 100),
            currentOperation: `Processing students ${processedCount +
              1}-${Math.min(processedCount + chunk.length, totalStudents)}...`,
          })
        );

        // Process chunk
        const response = await axios.post(
          "/api/school-programs-bulk-upload/process",
          {
            students: chunk,
            programId,
            branchId,
            courseId,
            branchCourseFeeId,
            courseFee,
          }
        );

        // Aggregate results
        allResults.success.push(...(response.data.success || []));
        allResults.failed.push(...(response.data.failed || []));

        processedCount += chunk.length;

        // Update progress
        dispatch(
          updateProgress({
            current: processedCount,
            total: totalStudents,
            percentage: Math.round((processedCount / totalStudents) * 100),
            currentOperation: `Processed ${processedCount} of ${totalStudents} students`,
          })
        );

        // Small delay between chunks for better UX
        if (i < chunks.length - 1) {
          await new Promise((resolve) => setTimeout(resolve, 500));
        }
      }

      // Final update
      dispatch(
        updateProgress({
          current: totalStudents,
          total: totalStudents,
          percentage: 100,
          currentOperation: "Complete!",
        })
      );

      dispatch(
        setResults({
          success: allResults.success,
          failed: allResults.failed,
          totalProcessed: totalStudents,
          successCount: allResults.success.length,
          failedCount: allResults.failed.length,
        })
      );

      setProcessing(false);
      return true;
    } catch (error) {
      console.error("Processing error:", error);
      dispatch(
        setError(
          error.response?.data?.error || error.message || "Processing failed"
        )
      );
      dispatch(setProcessingStatus("error"));
      setProcessing(false);
      return false;
    }
  };

  return {
    processUpload,
    processing,
  };
};
